/**
 * Module-level holder for the active operation mode (sandbox vs production).
 *
 * The HTTP layer (`apiFetcher.ts`) reads this on every outbound request to
 * stamp the `X-DWPay-Mode` header. We can't reach into React from the axios
 * interceptor, so we mirror the existing `setAdminAccessToken` /
 * `setPortalAccessToken` pattern: the React provider (`ModeProvider`) calls
 * `setCurrentMode()` whenever its state changes, and any non-React caller
 * reads `getCurrentMode()`.
 *
 * Default is `'production'` — the safest fallback for a user whose mode
 * preference hasn't been hydrated from localStorage yet.
 */
export type OperationMode = 'production' | 'sandbox';

let currentMode: OperationMode = 'production';

export function setCurrentMode(next: OperationMode): void {
  currentMode = next;
}

export function getCurrentMode(): OperationMode {
  return currentMode;
}
